import { ensureElement } from "../utils/utils";
import { Component } from "./base/Component";
export class Success extends Component {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._button = ensureElement('.order-success__close', this.container);
        this._description = ensureElement('.order-success__description', this.container);
        this._button.addEventListener('click', () => {
            this.events.emit('success:close');
        });
    }
    set total(value) {
        this.setText(this._description, `Списано ${value} синапсов`);
    }
}
